/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */
  // 后台管理系统服务器地址


// let url = ""
// /*第一层if判断生产环境和开发环境*/
// if (process.env.NODE_ENV === 'production') {
//   /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
//   url = 'https://sd-cx-api.sdjpw.cn/adm';
// } else {
//   //dev 开发环境
//   // url = 'http://localhost:8052';
//   url = 'http://t1-sd-cx-api.sdjpw.cn/adm'; 
// }
// export const baseUrl = url
export const baseUrl = process.env.PROJECT_INTERFACE_DOMAIN
// 系统数据备份还原服务器地址
export const backupBaseUrl = ''

export const imgUrl = 'http://localhost/u/'

export default {
  baseUrl,
  backupBaseUrl,
  imgUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js